// import styles from "./InstaTac.module.scss";
import React from "react";
import Img from "../Img";
import Tac from "../../types/Tac";
import Popover from "../Popover";

export interface Props {
    tac: Tac,
}

export const InstaTac = (props: Props) => {
    const style={
        animation: "ntFadeInOut 7s",
        padding: "0.2em",
        borderRadius: "0",
        boxShadow: "0px 0px 30px 0px rgba(0, 0, 0, 0.6)",
        border: "none",
    };

    return (
        <Popover confetti style={style}>
            <Img className="insta-img" renditions={props.tac.image.optimized} size="80vw" />
        </Popover>
    );
};

export default InstaTac;
